import _ from 'lodash';

const getMboxItems = items => _.uniqBy(items, item => item.uniqueId || item.id);

export { getMboxItems };
